<script setup lang="ts">

import { useUserSettings } from "@services/UserSettings";
import { useIsHostedInBrowser } from "@modules/Jupiter"
import { usePairingState } from '../Types/UsePairingState';
import { formatDate } from "@library/Utilities";
import type { IMyGarageViewModel } from "@app/MyGarage/Types/IMyGarageViewModel";
import { DeviceInstallationStatus } from "@domain/General/DeviceInstallationStatus/DeviceInstallationStatus";
import { AutoInstalledState } from "@domain/General/Enums/AutoInstalledState";

type Props = { model: IMyGarageViewModel }
const { model } = defineProps<Props>();
const isOpen = defineModel<boolean>( { required: true } );
const isHostedInBrowser = useIsHostedInBrowser();
const pairing = usePairingState();
const settings = useUserSettings();

</script>

<template>

    <div class="fixed bottom-0 left-0 w-full h-[100%] flex flex-col justify-end
                z-50 pointer-events-none 3xl:left-auto 3xl:max-w-xl 3xl:m-auto
                bg-gradient-to-b from-transparent to-black/30 via-30% via-black/30
                translate-y-12 opacity-0 transition-[transform,opacity] duration-300"
         :class="{
            '!opacity-100 !translate-y-0 pointer-events-auto': isOpen
         }"
         @click="() => isOpen = false">

        <div class="rounded-t-xl p-4 3xl:p-6
                    bg-gradient-to-b from-gray-850 to-gray-900"
             :class="{
                 '!pb-12': isHostedInBrowser 
             }">
        
            <div class="flex items-center justify-center pb-2">
                <div class="absolute rounded-full h-1 w-10 bg-white/10"/>
            </div>

            <div class="flex justify-center pt-2 text base lg:text-lg 3xl:text-2xl text-white tracking-wider pb-2">
                Health Monitor pairing diagnostics
            </div>

            <div class="grid grid-cols-[66%_auto] gap-2 mt-4 text-base tracking-wider">
            
                <div>Installation status</div>
                <div class="text-right">{{ DeviceInstallationStatus.toString( model.carePlan.healthMonitor.status ) }}</div>

                <div>User setting set to</div>
                <div class="text-right">{{ AutoInstalledState.toString( settings.healthMonitorEnabledState ) }}</div>

                <div>Is paired</div>
                <div class="text-right">{{ model.carePlan.healthMonitor.isPaired ? 'Yes' : 'No' }}</div>

                <div>Last paired</div>
                <div class="text-right">{{ model.carePlan.healthMonitor.utcDateLastPaired == null ? '-' : formatDate( model.carePlan.healthMonitor.utcDateLastPaired, 'DD-MM-YYYY HH:mm' ) }}</div>

                <div>Last scan</div>
                <div class="text-right">{{ model.carePlan.healthMonitor.utcDateInstalled == null ? '-' : formatDate( model.carePlan.healthMonitor.utcDateLastScan, 'DD-MM-YYYY HH:mm' ) }}</div>

                <div>Connection attempts</div>
                <div class="text-right">{{ pairing.numberofPairingAttempts }}</div>

                <div>Is enabled</div>
                <div class="text-right">{{ model.carePlan.healthMonitor.isEnabled ? 'Yes' : 'No' }}</div>

                <div>Is enabled in app</div>
                <div class="text-right">{{ model.carePlan.healthMonitor.isEnabledInAppSettings ? 'Yes' : 'No' }}</div>

            </div>

        </div>

    </div>

</template>